require('intersection-observer')

export default {
  init() {}, // eslint-disable-line @typescript-eslint/no-empty-function, no-empty-function
}
